// Template Registry
import DefaultNavbarTemplate from './DefaultNavbarTemplate';
import MegaMenuTemplate from './MegaMenuTemplate';
import CarouselTemplate from './CarouselTemplate';
import ModernMinimalTemplate from './ModernMinimalTemplate';

export const NAVBAR_TEMPLATES = {
  default: DefaultNavbarTemplate,
  megamenu: MegaMenuTemplate,
  carousel: CarouselTemplate,
  modern: ModernMinimalTemplate,
};

// Template positioning preferences
export const TEMPLATE_POSITIONS = {
  default: 'left',      // Centered in toolbar
  megamenu: 'left',       // Next to logo
  carousel: 'center',     // Centered in toolbar
  modern: 'right',        // Right side (before user controls)
};

export const getTemplate = (templateName = 'default') => {
  return NAVBAR_TEMPLATES[templateName] || NAVBAR_TEMPLATES.default;
};

export const getTemplatePosition = (templateName = 'default') => {
  return TEMPLATE_POSITIONS[templateName] || 'center';
};

export {
  DefaultNavbarTemplate,
  MegaMenuTemplate,
  CarouselTemplate,
  ModernMinimalTemplate,
};